import React, { useEffect } from 'react';
import Sidebar from 'src/components/common/Sidebar';
import RodeoEventGamePage from 'src/components/events/rodeoEventGame/rodeoEventGamePage';
import { APPLICATION_NAME, RODEO_PAGE_NAME } from 'src/_config';
import Footer from 'src/components/common/Footer';

export default function RodeoEventGameContainer() {

    useEffect(() => {
        const prevTitle = document.title
        document.title = `${APPLICATION_NAME} : Event List`
        return () => {
          document.title = prevTitle
        }
      }, [])

    return (
        <React.Fragment>
            <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
            <section className="main-container py-0">
                <RodeoEventGamePage />
            </section>
            <Footer/>
        </React.Fragment>
    )
}
